var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000085242757460621127630000008768760920737594798_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 7.2,
    y: 7.2,
    width: 88.7,
    height: 88.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000142174532978441186840000016086689932140523703_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000142174532978441186840000016086689932140523703_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,48.7c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6C33.3,47.6,34.5,48.7,35.9,48.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1,48.7c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6C64.5,47.6,65.6,48.7,67.1,48.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1,61.7c-1.4,0-2.6,1.2-2.6,2.6c0,2.9-2.3,5.2-5.2,5.2c-2.9,0-5.2-2.3-5.2-5.2v-1.5l4.4-4.4c0.5-0.5,0.8-1.1,0.8-1.8 c0-4.3-3.5-7.8-7.8-7.8s-7.8,3.5-7.8,7.8c0,0.7,0.3,1.4,0.8,1.8l4.4,4.4v1.5c0,2.9-2.3,5.2-5.2,5.2c-2.9,0-5.2-2.3-5.2-5.2 c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6c0,5.7,4.7,10.4,10.4,10.4v8c0,1.4,1.2,2.6,2.6,2.6h10.4c1.4,0,2.6-1.2,2.6-2.6v-8 c5.7,0,10.4-4.7,10.4-10.4C69.7,62.9,68.5,61.7,67.1,61.7z M51.5,53.9c1.1,0,2.1,0.7,2.4,1.7L51.5,58l-2.4-2.4 C49.4,54.6,50.4,53.9,51.5,53.9z M54.1,80.1h-5.2v-6.8c1-0.6,1.9-1.3,2.6-2.1c0.7,0.8,1.6,1.6,2.6,2.1V80.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4,7.7c-7.6-2-14.9,1.7-18.2,8.1c-4.6-2.3-9.5-3.4-14.5-3.4c-5,0-10.1,1.1-14.8,3.3c-3.2-6.3-10.4-10-18-8 C8,10.5,3.8,23,10.1,31.7c2.2,3,5.2,5.1,8.7,6.1c-0.7,2.7-1,5.4-1,8.2c-0.2,2.1,0.8,5.6-2.5,12.1c-3.5,7-3.7,15.3-0.3,22.6 c3.3,7.2,9.4,12.4,16.8,14.3c2.9,0.7,5.8,1,8.6,0.8c7.4-0.5,14.9-0.5,22.3,0c2.9,0.2,5.8-0.1,8.6-0.8c7.5-1.9,13.7-7.2,17-14.4 c3.3-7.3,3.2-15.5-0.3-22.5c-2.5-4.9-2.6-9.2-2.5-10.1c0.2-0.8,0-5.5-1.2-10.2c3.5-0.9,6.6-3,8.8-6C99.1,23.2,95,10.4,84.4,7.7z  M43.7,18.6c2.5-0.7,5.1-1.1,7.8-1.1c2.9,0,5.4,0.4,7.8,1.1v6.2c0,4.4-3.2,8.4-8,8.3c-4.3-0.1-7.6-3.6-7.6-7.8V18.6z M14.3,28.7 c-4.2-5.9-1.3-14.1,5.8-16c5.6-1.4,10.3,1.5,12.2,5.6C27,22,22.9,27.1,20.5,32.8C18,32.3,15.8,30.8,14.3,28.7z M83.5,78.4 c-2.7,5.8-7.6,10-13.5,11.5c-2.3,0.6-4.7,0.8-7,0.6c-7.6-0.5-15.4-0.5-23,0c-2.3,0.2-4.6-0.1-7-0.6c-5.9-1.5-10.8-5.7-13.4-11.4 c-2.7-5.9-2.6-12.5,0.2-18.1c3.3-6.6,3-10.6,3-14.3c0-10.9,6.2-20.6,15.6-25.5v4.7c0,7.1,5.8,13,13,13c7.6,0,13-6.4,13-13.5v-4 c9.2,4.9,15.6,15.1,15.8,26.3c-0.2,1.4-0.1,7.1,3,13.3C86.1,66,86.1,72.6,83.5,78.4z M88.7,28.8c-1.5,2.1-3.8,3.6-6.3,4.1 c-2.6-5.8-6.6-10.9-11.7-14.5c2.1-4.5,7.3-7,12.4-5.7C90,14.5,92.9,23,88.7,28.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamster);
export default __webpack_public_path__ + "static/media/hamster.c8223fbd95fdbfa896d7efc260de82e5.svg";
export { ForwardRef as ReactComponent };